'use client';

import { cn } from '../../utils/cn';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'destructive';
}

export function Badge({ 
  children, 
  className, 
  variant = 'default',
  ...props 
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variant === 'default' && 'bg-zinc-900 text-white',
        variant === 'secondary' && 'bg-zinc-100 text-zinc-900',
        variant === 'outline' && 'border border-zinc-200 text-zinc-700',
        variant === 'destructive' && 'bg-red-100 text-red-700',
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
